import React from 'react';
import moment from 'moment';
import { defineMessages, FormattedMessage } from 'react-intl';

const messages = defineMessages({
  SubtractOneMonth: '-1 month',
  AddOneMonth: '+1 month',
  PreviousMonth: 'Previous month',
  CurrentMonth: 'Current month',
  CurrentYear: 'Current year',
  DateFrom: 'From',
  DateUntil: 'Until',
  SubtractOneWeek: '-1 week',
  AddOneWeek: '+1 week',
  PreviousWeek: 'Previous week',
  CurrentWeek: 'Current week',
});

const currentYearStart = moment.utc().startOf('year');
const currentYearEnd = moment.utc().endOf('year');
const currentMonth = moment.utc().startOf('month');
const currentMonthEnd = moment.utc().endOf('month');
const currentYear = moment.utc().year();

const yearOffsets = [4, 3, 2, 1, 0];

function HoursPerEmployeeReportPeriods({ filters = {}, onChangeDate }) {
  const { dateFrom, dateUntil, groupBy } = filters;
  const currentWeek = moment.utc().startOf('week');
  const currentWeekEnd = moment.utc().endOf('week');
  const dateUntilLastDay =
    dateUntil && moment(dateUntil).isSame(moment(dateUntil).endOf('month'), 'day');
  if (groupBy === 4) {
    return (
      <div className="row">
        <div className="col-lg-12 col-md-6">
          <div className="form-group">
            <label className="control-label">
              <FormattedMessage {...messages.DateFrom} />
            </label>
            <div className="btn-group">
              {yearOffsets.map(x => {
                const startDate = moment(currentYearStart).subtract(x, 'y');
                const endDate = dateUntil;

                return (
                  <button
                    type="button"
                    key={x}
                    className="btn btn-default"
                    disabled={startDate >= endDate}
                    onClick={() => {
                      document.activeElement.blur();
                      onChangeDate(startDate, endDate);
                      document.activeElement.classList.add('active');
                    }}
                  >
                    {currentYear - x}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
        <div className="col-lg-12 col-md-6">
          <div className="form-group">
            <label className="control-label">
              <FormattedMessage {...messages.DateUntil} />
            </label>
            <div className="btn-group">
              {yearOffsets.map(x => {
                const startDate = dateFrom;
                const endDate = moment(currentYearEnd).subtract(x, 'y');

                return (
                  <button
                    type="button"
                    key={x}
                    className="btn btn-default"
                    disabled={startDate >= endDate}
                    onClick={() => onChangeDate(startDate, endDate)}
                  >
                    {currentYear - x}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (groupBy === 3) {
    return (
      <div className="form-group">
        <div className="btn-group btn-group-justified">
          <button
            type="button"
            className="btn btn-default"
            onClick={() =>
              onChangeDate(
                moment(dateFrom).subtract(1, 'month'),
                dateUntil
                  ? dateUntilLastDay
                    ? moment(dateUntil)
                        .subtract(5, 'day')
                        .subtract(1, 'month')
                        .endOf('month')
                    : moment(dateUntil).subtract(1, 'month')
                  : null,
              )
            }
          >
            <FormattedMessage {...messages.SubtractOneMonth} />
          </button>
          <button
            type="button"
            className="btn btn-default"
            onClick={() =>
              onChangeDate(
                moment(dateFrom).add(1, 'month'),
                dateUntil
                  ? dateUntilLastDay
                    ? moment(dateUntil)
                        .subtract(5, 'day')
                        .add(1, 'month')
                        .endOf('month')
                    : moment(dateUntil).add(1, 'month')
                  : null,
              )
            }
          >
            <FormattedMessage {...messages.AddOneMonth} />
          </button>
          <button
            type="button"
            className="btn btn-default"
            onClick={() =>
              onChangeDate(
                moment(currentYearStart).add(-2, 'y'),
                moment(currentYearEnd).add(-2, 'y'),
              )
            }
          >
            {currentYear - 2}
          </button>
          <button
            type="button"
            className="btn btn-default"
            onClick={() =>
              onChangeDate(
                moment(currentYearStart).add(-1, 'y'),
                moment(currentYearEnd).add(-1, 'y'),
              )
            }
          >
            {currentYear - 1}
          </button>
          <button
            type="button"
            className="btn btn-default"
            onClick={() => onChangeDate(moment(currentYearStart), moment(currentYearEnd))}
          >
            <FormattedMessage {...messages.CurrentYear} />
          </button>
        </div>
      </div>
    );
  }
  return (
    <>
      <div className="form-group">
        <div className="btn-group btn-group-justified margin5B">
          <button
            type="button"
            className="btn btn-default"
            onClick={() =>
              onChangeDate(
                moment(dateFrom).subtract(1, 'week'),
                dateUntil ? moment(dateUntil).subtract(1, 'week') : null,
              )
            }
          >
            <FormattedMessage {...messages.SubtractOneWeek} />
          </button>
          <button
            type="button"
            className="btn btn-default"
            onClick={() =>
              onChangeDate(
                moment(currentWeek).subtract(1, 'week'),
                moment(currentWeekEnd).subtract(1, 'week'),
              )
            }
          >
            <FormattedMessage {...messages.PreviousWeek} />
          </button>
          <button
            type="button"
            className="btn btn-default"
            onClick={() => onChangeDate(moment(currentWeek), moment(currentWeekEnd))}
          >
            <FormattedMessage {...messages.CurrentWeek} />
          </button>
          <button
            type="button"
            className="btn btn-default"
            onClick={() =>
              onChangeDate(
                moment(dateFrom).add(1, 'week'),
                dateUntil ? moment(dateUntil).add(1, 'week') : null,
              )
            }
          >
            <FormattedMessage {...messages.AddOneWeek} />
          </button>
        </div>
      </div>
      <div className="form-group">
        <div className="btn-group btn-group-justified">
          <button
            type="button"
            className="btn btn-default"
            onClick={() =>
              onChangeDate(
                moment(dateFrom).subtract(1, 'month'),
                dateUntil
                  ? dateUntilLastDay
                    ? moment(dateUntil)
                        .subtract(5, 'day')
                        .subtract(1, 'month')
                        .endOf('month')
                    : moment(dateUntil).subtract(1, 'month')
                  : null,
              )
            }
          >
            <FormattedMessage {...messages.SubtractOneMonth} />
          </button>
          <button
            type="button"
            className="btn btn-default"
            onClick={() =>
              onChangeDate(
                moment(currentMonth).subtract(1, 'month'),
                moment(currentMonth)
                  .subtract(1, 'month')
                  .endOf('month'),
              )
            }
          >
            <FormattedMessage {...messages.PreviousMonth} />
          </button>
          <button
            type="button"
            className="btn btn-default"
            onClick={() => onChangeDate(moment(currentMonth), moment(currentMonthEnd))}
          >
            <FormattedMessage {...messages.CurrentMonth} />
          </button>
          <button
            type="button"
            className="btn btn-default"
            onClick={() =>
              onChangeDate(
                moment(dateFrom).add(1, 'month'),
                dateUntil
                  ? dateUntilLastDay
                    ? moment(dateUntil)
                        .subtract(5, 'day')
                        .add(1, 'month')
                        .endOf('month')
                    : moment(dateUntil).add(1, 'month')
                  : null,
              )
            }
          >
            <FormattedMessage {...messages.AddOneMonth} />
          </button>
        </div>
      </div>
    </>
  );
}

export default HoursPerEmployeeReportPeriods;
